// import 'es6-promise/auto';
// import 'babel-polyfill';

import Vue from 'vue'
import Buefy from 'buefy'
import { VLazyImagePlugin } from 'v-lazy-image'
import { sync } from 'vuex-router-sync'
// import VueAnalytics from 'vue-analytics';

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'
import * as filters from './util/filters'
import './assets/scss/app.scss'
import './css/style.css'

Vue.use(Buefy)
Vue.use(VLazyImagePlugin)

Sentry.init({
  dsn: 'https://2217d31df447456cbfe6a723c8c107d5@sentry.io/1442250',
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true,
    }),
  ],
})

// register global utility filters.
Object.keys(filters).forEach((key) => Vue.filter(key, filters[key]))

Vue.config.productionTip = false

sync(store, router)

// Vue.use(VueAnalytics, {
//   id: 'UA-8243297-1',
//   router,
// });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
